export default "__VITE_ASSET__CHYCzJlM__"